// DashboardSwitcher — one screen with a Hotel / Restaurant toggle on top.
// Defaults to the Hotel dashboard; the user can switch to the Restaurant one.
import React, { useState, useEffect } from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import HotelIcon from '@mui/icons-material/Hotel';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import Dashboard from './Dashboard';
import ResturantDashbord from './ResturantDashbord';

export default function DashboardSwitcher() {
  const [view, setView] = useState('hotel'); // default = hotel

  // Exactly ONE hard refresh after each login. Login.js sets the
  // 'pendingDashboardRefresh' flag on a successful login; we consume it here —
  // remove it BEFORE reloading so the post-reload mount (and React StrictMode's
  // double effect-invocation in dev) find no flag and never reload again. No
  // flag → no refresh (e.g. navigating back to the dashboard later does
  // nothing). One login → one refresh, never a loop.
  useEffect(() => {
    if (sessionStorage.getItem('pendingDashboardRefresh') === '1') {
      sessionStorage.removeItem('pendingDashboardRefresh');
      window.location.reload();
    }
  }, []);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          pt: 3,
          pb: 1.5,
          position: 'sticky',
          top: 0,
          zIndex: 30,
          bgcolor: '#f5f6fa',
        }}>
        <ToggleButtonGroup
          value={view}
          exclusive
          size='small'
          color='primary'
          onChange={(e, v) => v && setView(v)}
          sx={{
            bgcolor: '#fff',
            borderRadius: 999,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            '& .MuiToggleButton-root': {
              textTransform: 'none',
              fontWeight: 700,
              border: 'none',
              borderRadius: 999,
              px: 2.5,
            },
          }}>
          <ToggleButton value='hotel'>
            <HotelIcon sx={{ fontSize: 18, mr: 0.7 }} /> Hotel
          </ToggleButton>
          <ToggleButton value='restaurant'>
            <RestaurantIcon sx={{ fontSize: 18, mr: 0.7 }} /> Restaurant
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {view === 'hotel' ? <Dashboard /> : <ResturantDashbord />}
    </Box>
  );
}
